import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import NotFound from '../views/404.vue'
import Page from '@/views/Page.vue'

Vue.use(VueMeta)
Vue.use(VueRouter)

const routes = [
	{
		path: '/:slug?',
		name: 'Page',
		props: true,
		component: Page,
	},

	{
		path: '*',
		name: 'NotFound',
		component: NotFound,
	},
]

const router = new VueRouter({
	mode: 'history',
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0, behavior: 'smooth' }
		}
	},
})

export default router
